import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { CSidebar, CSidebarBrand, CSidebarNav } from '@coreui/react-pro'

import { AppSidebarNav } from './AppSidebarNav'

import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'

// sidebar nav config
import navigation from '../_nav'
import { getAssetUrl } from 'src/utils/prefixConfig'
import oxdrLogo from '../assets/brand/logo-oxdr.svg'
import { CaretLeftIcon, CaretRightIcon } from '@phosphor-icons/react'

const AppSidebar = () => {
  const dispatch = useDispatch()
  const unfoldable = useSelector((state) => state.app.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.app.sidebarShow)
  const userData = useSelector((state) => state.user?.userData)
  const currentCustomer = useSelector((state) => state.customer?.currentCustomer);

  // Show the sidebar the first time user data becomes available (after login).
  // Guarded with a ref so it runs ONCE — otherwise every /ping creates a new
  // userData object, re-firing this effect and forcing the sidebar back open,
  // which reverts a manual collapse (and the collapsed favicon logo) each ping.
  const didAutoShowRef = React.useRef(false);
  React.useEffect(() => {
    if (userData && !didAutoShowRef.current) {
      didAutoShowRef.current = true;
      dispatch({ type: 'set', sidebarShow: true });
    }
  }, [userData, dispatch]);

  const toggleSidebar = () => {
    dispatch({ type: 'set', sidebarShow: !sidebarShow });
  }

  return (
    <>
      <CSidebar
        position="fixed"
        unfoldable={unfoldable}
        visible={true}
        className={`sidebar-container z-0 ${sidebarShow ? '' : 'sidebar-collapsed'}`}
      >
        <CSidebarBrand className="d-none d-md-flex sidebar-brand" to="/">
          <img src={sidebarShow ? oxdrLogo : getAssetUrl('/assets/images/brand/invinsense_favicon.svg')} className="brand-logo" alt={sidebarShow ? 'OXDR' : 'Invinsense'} />
        </CSidebarBrand>
        <CSidebarNav>
          <SimpleBar>
            <AppSidebarNav items={navigation.getNavMenuItems(userData?.user, currentCustomer)} />
          </SimpleBar>
        </CSidebarNav>
      </CSidebar>

      {/* Floating Toggle Button on the sidebar border divider */}
      <button
        className={`sidebar-floating-toggle ${sidebarShow ? 'expanded' : 'collapsed'}`}
        onClick={toggleSidebar}
        title={sidebarShow ? "Collapse sidebar" : "Expand sidebar"}
        aria-label={sidebarShow ? "Collapse sidebar" : "Expand sidebar"}
      >
        {sidebarShow ? <CaretLeftIcon weight="bold" size={14} /> : <CaretRightIcon weight="bold" size={14} />}
      </button>
    </>
  )
}

export default React.memo(AppSidebar)
